import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import dayjs from 'dayjs';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/global.css';
import '@/assets/fonts/iconfont.css';
import router from '@/router';
import store from '@/store';

Vue.use(ElementUI);

// axios.defaults.baseURL = 'http://127.0.0.1:9857/wisharemedia/api/';
axios.defaults.baseURL = 'https://server.hbh.homes/wisharemedia/api/';
axios.interceptors.request.use(config => {
  config.headers.Authorization = window.sessionStorage.getItem('token');
  return config;
});
Vue.prototype.$http = axios;
Vue.prototype.$dayjs = dayjs;


Vue.config.productionTip = false;

const vue = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

export default vue;